import styled from '@emotion/styled';
import { mobile } from '@styles/index';

const ScaledImage = styled.div`
  height: ${({ $size, $height }) => `${$size || $height}px`};
  width: ${({ $size, $width }) => `${$size || $width}px`};
  position: relative;

  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin: auto;
  }

  img {
    height: ${({ $size, $height }) => `${($size || $height) * 8}px`};
    width: ${({ $size, $width }) => `${($size || $width) * 8}px`};
    position: absolute;
    left: 0;
    top: 0;
    transform: scale(0.125);
    transform-origin: 0 0;

    @media only screen and (max-width: ${mobile.maxWidth}) {
      margin-top: 0;
    }
  }
`;

export default ScaledImage;
